<mat-card appearance="outlined" class="project-card">
  <div class="card-content-wrapper">
    <mat-card-header>
      <a mat-card-title class="project-title" [routerLink]="['/project', project().id]">
        {{ project().name }}
      </a>
      <mat-card-subtitle>Created: {{ project().createdAt | date:'mediumDate' }}</mat-card-subtitle>
    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content>
      <div class="topic-section">
        <span class="topic-text">{{ project().topic || 'No topic specified' }}</span>
      </div>
    </mat-card-content>

    <!--<<mat-card-actions align="end">
     <a [routerLink]="['/project', project().id]" mat-button color="primary">
       <mat-icon>visibility</mat-icon>
       View
     </a>
    button mat-button color="accent">
       <mat-icon>share</mat-icon>
       SHARE
     </button>
    </mat-card-actions>
    -->
  </div>
</mat-card>
